<template>
  <div class=" row-middle" :class="isBtn ? 'ZSendSms__codeBtn' : 'ZSendSms__codeBtn_disabled'">
    {{ getCodeText }}
  </div>
</template>

<script>
import bus from '@/utils/bus'
export default {
  name: 'ZSendSms',
  data() {
    return {
      leftTime: 0,
      smsState: {},
      timeOut: null,
      waitState: 0
    }
  },
  computed: {
    getCodeText() {
      if (this.leftTime <= 0) {
        return '发送验证码'
      } else {
        return this.leftTime + ''
      }
    },
    isBtn() {
      if (this.leftTime <= 0) {
        return true
      } else {
        return false
      }
    }
  },
  destroyed() {
    if (this.timeOut) {
      clearTimeout(this.timeOut)
    }
    bus.$off('sendSms')
  },
  mounted() {
    const self = this
    bus.$on('sendSms', (call) => {
      if (self.leftTime > 0 || this.waitState) {
        return
      }
      this.waitState = true
      call((err) => {
        if (!err) {
          self.smsState.sendTime = new Date()
          self.sendMsgTime()
        }
        this.waitState = false
      })
    })
  },
  watch: {
  },
  methods: {
    sendMsgTime() {
      if (this.smsState && this.smsState.sendTime) {
        if (this.timeOut) {
          clearTimeout(this.timeOut)
        }
        this.leftTime = parseInt(this.smsState.sendTime.getTime() / 1000 + 60 - new Date().getTime() / 1000)
        this.timeOut = setTimeout(() => {
          const lastLeftTime = this.leftTime
          this.leftTime = parseInt(this.smsState.sendTime.getTime() / 1000 + 60 - new Date().getTime() / 1000)
          if (lastLeftTime !== this.leftTime) {
            this.$emit('change', this.leftTime)
          }
          if (this.leftTime > 0) {
            this.sendMsgTime()
          }
        }, 200)
      }
    }
  }
}
</script>

<style scoped>
.ZSendSms-getCode {
  color: #009CFF;
}

.ZSendSms__codeBtn {
  width: 147px;
  height: 28px;
  color: #009CFF;
  font-size: 15px;
}

.ZSendSms__codeBtn_disabled {
  width: 147px;
  height: 28px;
  color: #dddddd;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ZSendSms/index.vue